module.exports = __webpack_public_path__ + "img/logo-no-bg.7718b3e3.svg";